import { Observable } from 'rxjs'
import { MbCheckoutReviewModel } from '../../../models'

export abstract class MbCheckoutReviewNotesAdapter {

  abstract load(cartID: string): Observable<MbCheckoutReviewModel>

  abstract post(form: MbCheckoutReviewModel, cartID: string): Observable<any>
}
